const convertToMB = (value, unit) => {
    return value !== null
        ? (value / (unit === 'bytes' ? 1024 * 1024 : 1024)).toFixed(2) + ' MB'
        : ''
}

export { convertToMB }
